import styled, { css } from 'styled-components';
import {
  onSurface,
  onSurfaceVariant,
  outlineVariant,
  popoverShadow,
  primary,
  radiusFull,
  surface,
  surfaceHigh,
} from '../themeTokens';
import { CHROME_INSET_PX } from './chrome.constants';

export const Bar = styled.div<{ $docked: boolean }>`
  z-index: 4;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  padding: 3px 6px;
  border-radius: ${radiusFull};
  background: ${surface};
  color: ${onSurface};
  box-shadow: ${popoverShadow};
  pointer-events: auto;

  ${({ $docked }) =>
    $docked
      ? css`
          position: absolute;
          left: 50%;
          bottom: ${CHROME_INSET_PX + 52}px;
          translate: -50% 0;
          max-width: calc(100% - ${CHROME_INSET_PX * 2}px);
          justify-content: center;
          border-radius: 18px;
        `
      : css`
          position: absolute;
          top: 0;
          left: 0;
          visibility: hidden;
          white-space: nowrap;
        `}
`;

export const AxisChip = styled.button<{ $color: string; $active: boolean }>`
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  color: ${(p) => (p.$active ? '#fff' : p.$color)};
  background: ${(p) => (p.$active ? p.$color : 'transparent')};

  &:hover {
    background: ${(p) => (p.$active ? p.$color : surfaceHigh(p))};
  }

  &:focus-visible {
    outline: 2px solid ${primary};
    outline-offset: 1px;
  }
`;

export const Divider = styled.span`
  width: 1px;
  height: 18px;
  margin: 0 2px;
  background: ${outlineVariant};
`;

export const Field = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: ${onSurfaceVariant};
`;

export const FieldInput = styled.input`
  width: 64px;
  height: 26px;
  padding: 0 8px;
  border: 1px solid ${outlineVariant};
  border-radius: 8px;
  background: ${surfaceHigh};
  color: ${onSurface};
  font: inherit;
  font-variant-numeric: tabular-nums;
  text-align: right;

  &:focus {
    outline: none;
    border-color: ${primary};
  }
`;
